"use client";

import { Suspense } from "react";
import dynamic from "next/dynamic";
import ErrorBoundaryWithToast from "@/app/ErrorBoundaryWithToast";
import useSearchListingPropertiesCount from "hooks/swr/useSearchListingPropertiesCount";
import { useMediaQuery } from "utils/hooks/useMediaQuery";
const HeaderSearch = dynamic(() => import( /* webpackChunkName: "HeaderSearch" */"components/modals/search-bar-model"), {
  ssr: false,
  loading: () => <div className='h-11 w-[380px] rounded-[100px] border border-gray-200 bg-white' />
});
const FilterProperty = dynamic(() => import( /* webpackChunkName: "FilterProperty" */"components/pages/vacation-rentals/MoreFilters/FilterProperty"), {
  ssr: false,
  loading: () => <div className='hidden h-12 w-[100px] rounded-3xl border border-[#EEEEEE] bg-primary-500 lg:flex' />
});
const SearchPill = () => {
  const [isLargerThan992] = useMediaQuery("(min-width: 992px)");
  const {
    data: countApiResponse
  } = useSearchListingPropertiesCount();
  return <div data-sentry-component="SearchPill" data-sentry-source-file="SearchPill.tsx">
      {/* // search bar [desktop view] for the vacation-rental page */}
      {isLargerThan992 && <Suspense fallback={null}>
          <div className='flex items-center gap-2 lg4:gap-[15px]'>
          <ErrorBoundaryWithToast location='HeaderSearch'>
              <HeaderSearch />
          </ErrorBoundaryWithToast>
          <ErrorBoundaryWithToast location='FilterProperty'>
              <FilterProperty expandedMiles={countApiResponse?.expandedRadiusMiles} />
          </ErrorBoundaryWithToast>
          </div>
        </Suspense>}
    </div>;
};
export default SearchPill;